import { render, staticRenderFns } from "./DailyLeads.vue?vue&type=template&id=816a3d20&scoped=true&"
import script from "./DailyLeads.vue?vue&type=script&lang=js&"
export * from "./DailyLeads.vue?vue&type=script&lang=js&"
import style0 from "./DailyLeads.vue?vue&type=style&index=0&id=816a3d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816a3d20",
  null
  
)

export default component.exports